import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20abstract%20composition%20with%20warm%20golden%20and%20deep%20crimson%20gradient%20curves%2C%20film%20reel%20texture%20subtle%20pattern%2C%20luxury%20cinema%20atmosphere%2C%20soft%20elegant%20lighting%2C%20no%20text%2C%20abstract%20background%20for%20movie%20website%2C%20rich%20textures%2C%20warm%20ambient%20glow&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="努努影院 - 免费高清电视剧在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="努努影院 - 免费高清电视剧在线观看"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-heading text-2xl md:text-5xl font-bold text-background-50 mb-3 md:mb-4 leading-tight">
            <a href="/" className="text-background-50 hover:text-primary-300 transition-colors">
              努努影院
            </a>
          </h1>
          <p className="text-background-200/90 text-sm md:text-lg mb-2 md:mb-3 max-w-xl mx-auto leading-relaxed">
            高清电视剧全集免费在线观看，最新剧集实时更新
          </p>
          <p className="text-background-300/80 text-xs md:text-sm mb-6 md:mb-8 max-w-lg mx-auto">
            播放不缓冲，流畅追剧首选 · 覆盖国产剧、韩剧、美剧、日剧、泰剧、动漫
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/guochan"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-play-circle-line text-lg"></i>
              开始追剧
            </Link>
            <Link
              to="/category/hanju"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full border border-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-fire-line text-lg"></i>
              热门韩剧
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}